<template>
  <div class="containerTable">
    <div class="titleh1"><code />收款单</div>
    <el-row>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-col :span="8">
          <el-form-item label="单据编号" prop="documentNumber">
            <el-input
              v-model="form.documentNumber"
              maxlength="255"
              placeholder="请输入单据编号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收款日期" prop="payDate">
            <el-date-picker
              v-model="form.payDate"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="请选择收款日期"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="结算方式" prop="payType">
            <el-select v-model="form.payType" placeholder="请选择结算方式">
              <el-option label="转账" value="0" />
              <el-option label="承兑汇票" value="1" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="款项类型">
            <el-select v-model="form.feeType" placeholder="请选择款项类型">
              <el-option label="转账" value="0" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户名称" prop="shipmentCode">
            <el-input v-model="form.shipmentCode" style="display:none" />
            <el-input
              ref="id"
              v-model="form.shipmentName"
              placeholder="请输入客户名称"
              @click.native="Shipperlist()"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="应收金额">
            <el-input
              v-model="form.debtAmount"
              @input="
                value =>
                  formFormatter.isFloor2(value, oldValue, form, 'debtAmount')
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="单位账号">
            <el-input v-model="form.bankAccount" maxlength="255" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="单位银行">
            <el-input v-model="form.bankName" maxlength="255" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="交款人">
            <el-input v-model="form.payerName" maxlength="255" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收款金额" prop="payAmount">
            <el-input
              v-model="form.payAmount"
              placeholder="请输入收款金额"
              @input="
                value =>
                  formFormatter.isFloor2(value, oldValue, form, 'payAmount')
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="大写">
            <el-input :value="capitalizate" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input
              v-model="form.remark"
              type="textarea"
              :rows="2"
              maxlength="255"
              placeholder="请输入内容"
            />
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>

    <el-button
      v-if="receipt_submit_button"
      type="primary"
      @click="submitForm('form')"
    >
      立即提交
    </el-button>
    <el-button v-if="receipt_reset_button" @click="resetForm('form')">
      重置
    </el-button>
    <vxe-modal
      v-model="tuteship"
      title="选择托运人"
      width="1050"
      height="80%"
      resize
    >
      <customer ref="ShipperlRef" @event1="receive" />
    </vxe-modal>
  </div>
</template>
<script>
import { getLimit } from "@/utils/getLimit.js";
import customer from "./components/customer.vue";
import { collectionPut } from "@/api/category";
export default {
  components: {
    customer
  },
  data() {
    return {
      form: {
        documentNumber: "",
        payDate: "",
        payType: "",
        feeType: "",
        shipmentName: "",
        shipmentCode: "",
        debtAmount: "",
        bankAccount: "",
        bankName: "",
        payerName: "",
        payAmount: "",
        payAmountUpper: "",
        remark: ""
      },
      tuteship: false,
      receipt_submit_button: false, //立即提交
      receipt_reset_button: false, //重置
      rules: {
        documentNumber: [
          { required: true, message: "请输入单据编号", trigger: "blur" }
        ],
        payDate: [
          { required: true, message: "请选择收款日期", trigger: "blur" }
        ],
        payType: [
          {
            required: true,
            message: "请选择结算方式",
            trigger: ["blur", "change"]
          }
        ],
        shipmentCode: [
          { required: true, message: "请输入客户名称", trigger: "blur" }
        ],
        payAmount: [
          { required: true, message: "请输入收款金额", trigger: "blur" },
          { max: 10, message: "长度不超过10个字符", trigger: "blur" }
        ],
        remark: [{ max: 255, message: "长度不超过255个字符", trigger: "blur" }]
      }
    };
  },
  computed: {
    capitalizate() {
      let n = this.form.payAmount;
      if (n === "0") return "零分";
      let reg = /^(0|[1-9]\d*)(\.\d+)?$/;
      if (!reg.test(n)) return "";
      var unit = "仟佰拾亿仟佰拾万仟佰拾圆角分",
        str = "";
      n += "00";
      var p = n.indexOf(".");
      if (p >= 0) n = n.substring(0, p) + n.substr(p + 1, 2);
      unit = unit.substr(unit.length - n.length);
      for (var i = 0; i < n.length; i++)
        str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i);
      return str
        .replace(/零(仟|佰|拾|角)/g, "零")
        .replace(/(零)+/g, "零")
        .replace(/零(万|亿|圆)/g, "$1")
        .replace(/(亿)万|壹(拾)/g, "$1$2")
        .replace(/^圆零?|零分/g, "")
        .replace(/圆$/g, "圆整");
    }
  },
  created() {
    this.receipt_submit_button = getLimit("receipt_submit_button");
    this.receipt_reset_button = getLimit("receipt_reset_button");
  },
  methods: {
    submitForm(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.form.payAmountUpper = this.capitalizate;
          const rLoading = this.openLoading();
          collectionPut(this.form).then(response => {
            rLoading.close();
            this.$message({
              message: response.msg,
              type: "success"
            });
            this.$refs[form].resetFields();
            this.form.shipmentName = "";
            this.form.shipmentCode = "";
            this.form.debtAmount = "";
            this.form.feeType = "";
            this.form.bankName = "";
            this.form.payerName = "";
            this.form.remark = "";
            this.form.bankAccount = "";
          });
        } else {
          return false;
        }
      });
    },
    resetForm(form) {
      this.$refs[form].resetFields();
      this.form.shipmentName = "";
      this.form.shipmentCode = "";
      this.form.debtAmount = "";
      this.form.feeType = "";
      this.form.bankName = "";
      this.form.payerName = "";
      this.form.remark = "";
      this.form.bankAccount = "";
    },

    // 代发托运人方法
    Shipperlist() {
      this.$refs.ShipperlRef.shipmentlist();
      this.tuteship = true;
    },
    // 代发托运人子组件向父组件传值
    receive(data) {
      this.form.shipmentName = data.userName;
      this.form.shipmentCode = data.partyCode;
      this.form.debtAmount = data.debtAmount;
      this.tuteship = false;
      this.$refs.id.focus();
    }
  }
};
</script>
<style>
.titleh1 {
  line-height: 50px;
  border-bottom: 1px solid #e2e2e2;
  margin-bottom: 15px;
}
.titleh1 code {
  width: 5px;
  height: 20px;
  background-color: #ff7f21;
  float: left;
  margin-right: 5px;
  margin-top: 13px;
}
.el-autocomplete {
  width: 81%;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
